import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { EstateTaskUserTypeKey } from '@/modules/estatetask/enums/EstateTaskUserTypeKey';

export class WorkflowCreateEstateTaskAction extends BaseEntityModel {
  id?: number;

  assigneeType?: string;

  title?: string;

  description?: string;

  daysTillDue?: number;

  priority?: string;

  complexity?: string;

  type?: EstateTaskUserTypeKey;

  constructor(model: Partial<WorkflowCreateEstateTaskAction> = {}) {
    super(model);

    this.id = model.id;
    this.assigneeType = model.assigneeType;
    this.title = model.title;
    this.description = model.description ?? '';
    this.daysTillDue = model.daysTillDue;
    this.priority = model.priority;
    this.complexity = model.complexity;
    this.type = model.type;
  }
}
